import { QueryClient } from 'react-query'

export const queryClient = new QueryClient()

export const clearPatientQueryCache = async (): Promise<void> => {
  await queryClient.cancelQueries()
  queryClient.clear()
}
